export enum FileRoles {
  FILE_ROLE_CONTRACTS_AGREEMENTS = 'contracts-and-agreements',
  FILE_ROLE_PROSPECTUS = 'prospectus',
  FILE_ROLE_MARKETING_MATERIALS = 'marketing-materials',
  FILE_ROLE_SCHOOL_PHOTOS = 'school-photos',
  FILE_ROLE_SCHOOL_BANNER = 'school-banner',
  FILE_ROLE_MARKETING_LOGO = 'marketing-logo',
  FILE_ROLE_PROFILE_PDF = 'profile-pdf',
}
